import { useQuery } from '@tanstack/react-query'
import { listTransactions } from '../../../types'
import { actionApiCall } from '../api/actionApiCall'

export type TransactionFilters = {
    type?: 'EXPENSE' | 'TRANSFER'
    memberId?: string
    currencyCode?: string
    from?: string
    to?: string
    search?: string
    sort?: 'occurredAt' | 'amount' | 'title'
    order?: 'asc' | 'desc'
    limit?: number
    offset?: number
}

/**
 * Filtrovaná historie se načítá ze serveru. Nefiltrovaný pohled se bere
 * z uloženého snímku skupiny, takže funguje i offline.
 */
export function useFilteredTransactions(groupId: string, filters: TransactionFilters, enabled: boolean) {
    return useQuery({
        queryKey: ['transactions', groupId, filters],
        queryFn: () => actionApiCall(() => listTransactions({ path: { groupId }, query: filters })),
        enabled: enabled && !!groupId,
    })
}
